import React, { Component } from 'react';

import '../css/bg.css';
import '../css/main-page.css';

import routeConfig from '../config/route.json';
import comingSoonConfig from '../config/coming-soon.json';

import $ from 'jquery';
import { Scrollbars } from 'react-custom-scrollbars';

class RegisterOfTransactions extends Component {

  constructor(props) {
    super(props);
    let lang = window.location.hash.split('/')[1];


    this.state = {
      ...this.props,
      bg: {
        'pic1': '/bg/' + lang + '/register-of-transactions/main.png',
        'pic2': '/bg/' + lang + '/register-of-transactions/back-1.png',
        'pic3': '/bg/' + lang + '/register-of-transactions/front-1.png',
        'pic4': '/bg/' + lang + '/register-of-transactions/front-2.png'
      },
      lang: lang
    }
    $('#loader').fadeIn();
  }
  
  componentWillMount() {
    
  }
  
  componentDidMount() {
    let t = this;

    this.t1 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
    }, 500);
    this.t2 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
    }, 1500);
    this.t3 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
    }, 2500);
    this.t4 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
    }, 4000);
    this.t5 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
    }, 7000);

    this.props.updateLang();
    this.changePositioning();
    window.addEventListener('resize', this.changePositioning);

    $( "#bg-image-1" ).on('load', function() {
      t.pageLoad();
    });
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);

    clearTimeout(this.t1);
    clearTimeout(this.t2);
    clearTimeout(this.t3);
    clearTimeout(this.t4);
    clearTimeout(this.t5);
  }

  pageLoad () {
    let t = this;
    t.props.bgImageOnload();

    setTimeout(function(){
      document.getElementById('bg-image-2').classList.remove('bg-flower');
    }, 2200);
    setTimeout(function(){
      document.getElementById('bg-image-3').classList.remove('bg-flower');
    }, 3000);
    setTimeout(function(){
      document.getElementById('bg-image-4').classList.remove('bg-flower');
    }, 3900);
  }

  changePositioning() {
    let windowWidth = $('.App').width();

    if (windowWidth < 1100) {
      windowWidth = 1100
    }

    let bgImage2Top = windowWidth * 0.309 + 'px';

    document.getElementById('bg-image-2-container').style.top = bgImage2Top;


    $('.main-page-content-container').css({
      'height': $('.main-page-content-container').width() + 'px'
    })
    $('.main-page-content-content').css({
      'height': $('.main-page-content-content').width() * 0.6 + 'px'
    })
  }
  
  render() {
    let t = this;
    return <div className="main-page" style={{}}>
        <div id='bg-image-2-container'
          className='bg-image-container'
          style={{
            'right': '1px',
            'width': '50%'
          }}>
          <img src={this.state.bg.pic2} className='bg-image bg-flower' id='bg-image-2'/>
        </div>

        <img src={this.state.bg.pic1} className='bg-image' id='bg-image-1' style={{}}/>

        <div id='bg-image-3-container'
          className='bg-image-container'
          style={{
            'right': '1px',
            'width': '34%'
          }}>
          <img src={this.state.bg.pic3} className='bg-image bg-flower' id='bg-image-3'/>
        </div>
        <div id='bg-image-4-container'
          className='bg-image-container'
          style={{
            'left': '-3%',
            'width': '23%'
          }}>
          <img src={this.state.bg.pic4} className='bg-image bg-flower' id='bg-image-4'/>
        </div>

        <div id=''
          className='main-page-content-container'
          style={{
            'left': '9%',
            'width': '19%',
            'top': '64%',
            'height': '100px'
          }}>
          <div
            className='main-page-content-subtitle'
            style={{
              'fontSize': '16px'
            }}>
            {this.state.lang === 'en' ? 
              <img style={{'height': '88px', 'marginLeft': '-8px'}} src={routeConfig.registerOfTransactions[this.state.lang].titleUrl}/> : 
              routeConfig.registerOfTransactions[this.state.lang].name
            }
          </div>
          <Scrollbars
              renderTrackHorizontal={props => <div {...props} className="track-horizontal"/>}
              renderThumbHorizontal={props => <div {...props} className="thumb-horizontal"/>}
              // renderTrackVertical={props => <div {...props} className="track-vertical"/>}
              // renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}   
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              className='main-page-content-content'
              style={{
                'fontSize': '12px',
                'overflowX': 'hidden'
              }}>
            {this.state.data && this.state.data.register_of_transactions && this.state.data.register_of_transactions.length > 0 ?
              this.state.data.register_of_transactions.map(function(elem, idx){
                return <a className='item-button' key={idx} href={elem.url} target='_blank' style={{

                  }}>
                  <div className={(t.state.lang == 'en' ? 'item-is-eng' : 'item-is-chi')} style={{
                    'padding': '6px 0'
                  }}>
                    {elem[t.state.lang]}
                  </div>
                </a>
              }) : <div style={{
                'color': 'white',
                'padding': '6px 0',
                'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000'
              }}>{comingSoonConfig[t.state.lang]}</div>
            }
          </Scrollbars>
        </div>
    </div>
  }
};


export default RegisterOfTransactions;



// WEBPACK FOOTER //
// ./src/page/RegisterOfTransactions.js